export default {
  allItineraries: [],
}
